import type { RouteLocationNormalized } from 'vue-router'

import type { ObjectPlugin, Plugin } from '#app'
import { reportError } from '~/utils/error'

const plugin: Plugin & ObjectPlugin = defineNuxtPlugin({
  name: 'onChunkError',
  setup(nuxtApp) {
    const router = useRouter()

    const chunkErrors = new Set<Error>()

    router.beforeEach(() => {
      chunkErrors.clear()
    })

    nuxtApp.hook('app:chunkError', ({ error }) => {
      reportError(error)
      chunkErrors.add(error)
    })

    function reloadAppAtPath(to: RouteLocationNormalized) {
      reloadNuxtApp({ path: to.fullPath, persistState: true })
    }

    nuxtApp.hook('app:manifest:update', () => {
      router.beforeResolve(reloadAppAtPath)
    })

    router.onError((error, to) => {
      if (chunkErrors.has(error)) {
        reportError(error)
        reloadAppAtPath(to)
      }
    })
  },
})

export default plugin
